import { useMutation } from "@tanstack/react-query";
import { exportDevices } from "Infrastructure/Api/ApiCustom";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export function useExportDevicesMutation() {
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: exportDevices,
		onSuccess: (blob: Blob) => {
			// Create a link element and set it to download the Blob
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);

			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, "0");
			const day = String(now.getDate()).padStart(2, "0");
			const hours = String(now.getHours()).padStart(2, "0");
			const minutes = String(now.getMinutes()).padStart(2, "0");
			const seconds = String(now.getSeconds()).padStart(2, "0");
			const timestamp = `${year}${month}${day}_${hours}${minutes}${seconds}`;
			const instanceType =
				(import.meta.env.VITE_NAME as string)?.toLocaleLowerCase() ?? "";
			link.download = `export_${instanceType}_${timestamp}.xlsx`;
			link.click();
			URL.revokeObjectURL(link.href);
		},
		onError: () => {
			showSnackbar(t(Resources.Errors.Error500), "error");
		},
	});

	return mutation;
}
